<template>
  <button
    v-if="toggleTarget"
    :style="{ width: width ? `${width}px` : false, height: height ? `${height}px` : false }"
    :uk-toggle="`target: ${toggleTarget}`"
    class="uk-button action-button"
    :disabled="disabled"
    :type="type"
    :class="{
      [`uk-button-${color || 'default'}`]: true,
      round: shape === 'round'
    }"
    @click="onClick"
  >
    <div class="button-content"><span v-if="icon" :uk-icon="`icon: ${icon}`" class="icon"></span>{{ title }}</div>
  </button>
  <button
    v-else
    class="uk-button action-button"
    :disabled="disabled"
    :style="{ width: width ? `${width}px` : false }"
    :class="{
      [`uk-button-${color || 'default'}`]: true,
      round: shape === 'round'
    }"
    :type="type"
  >
    <ButtonLoading v-if="isLoading" :title="title" />
    <div v-else class="button-content"><span v-if="icon" :uk-icon="`icon: ${icon}`" class="icon"></span>{{ title }}</div>
  </button>
</template>
<style lang="scss" scoped>
.uk-button {
  border-radius: 5px !important;
}
.uk-button-default,
.uk-button-primary {
  &[disabled] {
    background-color: transparent !important;
    color: #999 !important;
    border-color: #e5e5e5 !important;
  }
}
.uk-button.round {
  border-radius: 20px !important;
}
.button-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon {
  margin-right: $spacing-small;
}
.uk-button-warn {
  border: 1px solid $error-color !important;
  color: $error-color !important;
  background-color: #fff;
}
</style>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import ButtonLoading from "./ButtonLoading.vue";

@Options({
  components: {
    ButtonLoading
  }
})
export default class ActionButton extends Vue {
  @Prop({ type: String }) title = "Button";
  @Prop({ type: String }) color: "primary" | "default" | "secondary" | "danger" | "warn" = "default";
  @Prop({ type: String }) shape: "round" | "rect" = "rect";
  @Prop({ type: String }) icon?: string;
  @Prop({ type: String }) toggleTarget?: string;
  @Prop({ type: String }) type: "button" | "submit" | "reset" = "button";
  @Prop({ type: Number }) width?: number;
  @Prop({ type: Number }) height?: number;
  @Prop({ type: Boolean }) disabled?: boolean = false;
  @Prop({ type: Boolean }) isLoading?: boolean = false;
}
</script>
